import React, { memo, useState } from "react";
import { Alert } from "../../../controls";

const sectorValidationChecks = (record) => {
  let error = false;
  let errorMessage = "";

  if (!error && !record.originAirportCode) {
    error = true;
    errorMessage = "'Origin Airport Code' is required";
  }
  if (!error && !record.destinationAirportCode) {
    error = true;
    errorMessage = "'Destination Airport Code' is required";
  }
  if (!error && !record.alternateAirportCode) {
    error = true;
    errorMessage = "'Alternate Airport Code' is required";
  }
  if (!error && !record.fuelPrice) {
    error = true;
    errorMessage = "'Fuel Price' is required";
  }
  return {error, errorMessage};
}

const CostingSectorsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  const {error, errorMessage} = sectorValidationChecks(record);

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

const AllCostingSectorsValidator = memo((props) => {
  const records = props.records;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  for (let i = 0; i < records.length; i++) {
    const record = records[i];
    const {error: recordError, errorMessage: recordErrorMessage} = sectorValidationChecks(record);
    if (recordError) {
      error = recordError;
      errorMessage = recordErrorMessage;
      break;
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert
      open={state.error}
      severity="error"
      canClose={false}
      message={state.errorMessage}
    />
  );
});

export default CostingSectorsValidator;
export {sectorValidationChecks, AllCostingSectorsValidator};
